import Vue from 'vue';
import jQuery from 'jquery';

// 将 jQuery 绑定到 Vue 原型中，以便在组件中使用 this.$jquery 或 this.$jQuery
Vue.prototype.$ = Vue.prototype.$jQuery = jQuery;
